export default __webpack_public_path__ + "static/media/logo-justiz.e70a3d10.png";